export class SearchOption {
  private _name: string;

  private constructor(name: string) {
    this._name = name;
  }

  public get name(): string {
    return this._name;
  }

  public get i18n_name(): string {
    return 'SEARCH.OPTION.' + this._name;
  }

  public equals(another: SearchOption): boolean {
    return another.name == this.name;
  }

  public static FirstLetters: SearchOption = new SearchOption('FIRST_LETTERS');
  public static Exact: SearchOption = new SearchOption('EXACT');
  public static Partial: SearchOption = new SearchOption('PARTIAL');
  public static Interval: SearchOption = new SearchOption('INTERVAL');
  public static SearchByEnum: SearchOption = new SearchOption('ENUM');
}
